<template>
  <el-dialog
    :title="$t(title)"
    :before-close="handlerClose"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="800px"
  >
    <el-form ref="form" :rules="rules" :model="form">
      <!-- 规则名称 -->
      <el-form-item :label="$t('1688')" prop="name" label-width="140px" v-if="!isView">
        <el-input v-model="form.name" :placeholder="$t('1688')" :maxlength="200"></el-input>
      </el-form-item>
      <!-- 年份 -->
      <el-form-item :label="$t('1848')" prop="year" label-width="140px">
        <el-date-picker
          :picker-options="pickerOptionsYear"
          value-format="yyyy"
          v-model="form.year"
          type="year"
          :placeholder="$t('1591')"
          @change="handleRemove"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 添加日期 -->
      <el-form-item label-width="140px" v-if="!isView">
        <el-button @click="doAdd" :disabled="!form.year" type="primary">{{ $t('1841') }}</el-button>
      </el-form-item>
      <!-- 列表 -->
      <el-table :data="form.date_list" border style="width: 100%" v-if="!isView">
        <!-- 日期 -->
        <!-- 超过当前日期则不显示 -->
        <el-table-column width="180" align="center">
          <template slot="header">
            <span class="required">*</span>
            {{ $t('307') }}
          </template>
          <template slot-scope="scope">
            <el-form-item
              class="margin-button-o"
              :prop="`date_list.${scope.$index}.date`"
              :rules="[{ required: true, message: $t('839') }]"
            >
              <el-date-picker
                style="width: 140px"
                :picker-options="pickerOptionsTime"
                v-model="scope.row.date"
                :placeholder="$t('839')"
                value-format="yyyy-MM-dd"
                :disabled="!scope.row.can_edit"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 英文名 -->
        <el-table-column align="center">
          <template slot="header">
            <span class="required">*</span>
            {{ $t('1843') }}
          </template>
          <template slot-scope="scope">
            <el-form-item
              :prop="`date_list.${scope.$index}.holiday_name_en`"
              :rules="[{ required: true, message: $t('17274_f3f50c56') }]"
              class="margin-button-o"
            >
              <el-input
                v-model="scope.row.holiday_name_en"
                :disabled="!scope.row.can_edit"
                :placeholder="$t('90')"
                :maxlength="200"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 中文名 -->
        <el-table-column :label="$t('1842')" align="center">
          <template slot-scope="scope">
            <el-form-item class="margin-button-o">
              <el-input
                v-model="scope.row.holiday_name_zh"
                :placeholder="$t('90')"
                :disabled="!scope.row.can_edit"
                :maxlength="200"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 泰文名 -->
        <el-table-column :label="$t('1844')" align="center">
          <template slot-scope="scope">
            <el-form-item class="margin-button-o">
              <el-input
                v-model="scope.row.holiday_name_th"
                :placeholder="$t('90')"
                :disabled="!scope.row.can_edit"
                :maxlength="200"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column fixed="right" :label="$t('70')" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDel(scope.$index)" :disabled="!scope.row.can_edit">{{
              $t('65')
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--
        仅isView下展示
        当仅查看的时候
      -->
      <el-table v-else :data="form.date_list">
        <!-- 日期 -->
        <el-table-column :label="$t('307')" align="center" prop="date" />
        <!-- 英中泰文 -->
        <el-table-column :label="$t('1843')" align="center" prop="holiday_name_en" />
        <el-table-column :label="$t('1842')" align="center" prop="holiday_name_zh" />
        <el-table-column :label="$t('1844')" align="center" prop="holiday_name_th" />
      </el-table>
    </el-form>
    <span slot="footer" class="dialog-footer" v-if="!isView">
      <el-button @click="handlerCancel">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="doSubmit" :loading="loading" :disabled="!this.form.date_list.length">{{
        $t('131')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { holidayAdd, holidayDetail, holidayEdit } from 'api/Attendance'

/**
 * @param { String } str 2021/11/15
 * @returns { Date }
 */
const createDate = str => {
  // return str.replaceAll('-', '/')
  return new Date(str.replaceAll('-', '/'))
}

// 假期规则参数
const listItem = year => ({
  can_edit: true,
  year,
  date: '',
  holiday_name_th: '',
  holiday_name_en: '',
  holiday_name_zh: ''
})
const form = () => ({
  // 规则名称
  name: '',
  // 年份
  year: '',
  // table list
  date_list: []
})
export default {
  props: {
    // 编辑或新建
    isEdit: {
      type: Boolean
    },
    // 是否仅查看
    isView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      if (this.isView) return this.form.name
      return this.isEdit ? '1845' : '1822'
    }
  },
  watch: {
    visible() {
      !this.isEdit && (this.form.year = String(new Date().getFullYear()))
    }
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: this.$t('850') }],
        year: [{ required: true, message: this.$t('839') }]
      },
      // save loading
      loading: false,
      // 弹窗展示
      visible: false,
      // 年份限制必须是当年及以后
      pickerOptionsYear: {
        disabledDate: time => {
          return time <= new Date()
        }
      },
      // 时间限制
      pickerOptionsTime: {
        disabledDate: time => {
          const { year } = this.form
          // 组件循环日期
          const cTime = time.getTime()
          // 当天的前一天
          const cuTime = new Date() - 86400000
          // 获取已选年份的最后一天
          const nextYear = new Date(String(Number(year) + 1)) - 86400000
          // 判断不能是以选日期
          const state = this.form.date_list.some(element => {
            if (!element.date) return false
            return createDate(element.date) - time === 0
          })
          // 必须是已选年份且必须大于当天
          return state || cTime < cuTime || time < new Date(year) - 86400000 || cTime > nextYear
        }
      },
      form: form(),
      // 编辑条目对应iD
      editId: '',
      // 编辑时查找所选年份是否有数据 并赋值给表格
      dateListMap: {},
      state: 0 // 0是新建 1是编辑
    }
  },
  methods: {
    // 获取详情
    async holidayDetail(id) {
      this.editId = id
      const year = String(new Date().getFullYear())
      // 默认当前年
      this.form.year = year
      const { data } = await holidayDetail({ id })
      if (data) {
        const { name, date_list } = data
        this.form.name = name
        this.dateListMap = date_list
        this.handleRemove(year)
      }
    },
    // 年份变换 逻辑上没有年份则不能保存
    handleRemove(v) {
      this.form.date_list = this.isEdit ? this.dateListMap[v] || [listItem(v)] : [listItem(v)]
    },
    // 删除当前行
    handleDel(index) {
      this.form.date_list.splice(index, 1)
    },
    // 添加行
    doAdd() {
      const { year, date_list } = this.form
      if (!year) return this.$message.warning(this.$t('1840'))
      date_list.push(listItem(year))
    },
    // 弹窗关闭前清空数据
    handlerClose(deno) {
      this.$refs.form.resetFields()
      this.form = form()
      if (deno) deno()
    },
    // 取消
    handlerCancel() {
      this.visible = false
      this.handlerClose()
    },
    // 提交
    doSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const request = this.isEdit ? holidayEdit : holidayAdd
          // 存储按钮loading
          this.loading = true
          request({ ...this.form, id: this.editId })
            .then(() => {
              // 关闭弹窗 表单还原
              this.visible = false
              // 列表刷新
              this.$emit('updateTable')
              this.handlerClose()
            })
            .finally(() => (this.loading = false))
        }
      })
    }
  }
}
</script>
<style scoped>
.required {
  display: inline-block;
  color: #f56c6c;
  transform: scale(0.8);
}
</style>
